export default "__VITE_ASSET__CsGBoHnw__"